import { gql } from '__generated__';

export default gql(`
  query GetContactFilters($project_id: ID!, $events: [ID!], $search: String, $locales: [Locale!], $mail_opt_ins: [ID!], $received_messages: [ID!], $will_receive_messages: [ID!]) {
    project(id: $project_id) {
      id
      mail_permissions {
        id
        title
      }
      messages {
        data {
          id
          title
        }
      }
      participant_stats(events: $events, search: $search, locales: $locales, mail_opt_ins: $mail_opt_ins, received_messages: $received_messages, will_receive_messages: $will_receive_messages) {
        participants
      }
    }
  }
`);
